import { FC, SelectHTMLAttributes } from 'react';
import { FormError } from './form';
import { cn } from '../../utility/cn';

interface SelectControlProps {
    touched?: boolean;
    error?: string;
    label?: string;
    required?: boolean;
    className?: string; // For the grid column wrapper (e.g., "col-lg-8")
    labelWidth?: string; // e.g., "col-lg-4"
    helpText?: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement>, SelectControlProps { }

export const Select: FC<SelectProps> = ({
    touched,
    error,
    className,
    children,
    ...props
}) => {
    const isInvalid = touched && error;

    return (
        <>
            <select
                className={cn(
                    'form-select form-select-solid form-select-lg fw-bold',
                    isInvalid && 'is-invalid',
                    className
                )}
                {...props}
            >
                {children}
            </select>
            <FormError error={isInvalid ? error : undefined} />
        </>
    );
};